import { createAsyncThunk } from '@reduxjs/toolkit';
import { contractsClient } from 'api/clients';
import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import {
  createContractSuccess,
  fetchContractsSuccess,
  requestFailure,
  requestStart,
  updateContractSuccess
} from './contractsSlice';

// === Get Contracts Thunk ===
export const getContractsThunk = createAsyncThunk(
  'contracts/getContracts',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const data = await contractsClient.getContracts();

      // Backend returns { success, ..., contracts: [...] }; older code expected a bare array.
      const contractList = Array.isArray(data) ? data : data?.contracts ?? [];
      const mappedContracts = contractList.map(contract =>
        mapKeys(contract, (_, key) => camelCase(key))
      );

      dispatch(fetchContractsSuccess(mappedContracts));
    } catch (error) {
      dispatch(requestFailure(error.message));
    }
  }
);

// === Create Contract Thunk ===
export const createContractThunk = createAsyncThunk(
  'contracts/createContract',
  async (contractData, { dispatch }) => {
    dispatch(requestStart());
    try {
      const { contract } = await contractsClient.createContract(contractData);

      const constMappedContract = mapKeys(contract, (_, key) => camelCase(key));

      dispatch(createContractSuccess(constMappedContract));
      return contract;
    } catch (error) {
      dispatch(requestFailure(error.message));
    }
  }
);

// === Update Contract Thunk ===
export const updateContractThunk = createAsyncThunk(
  'contracts/updateContract',
  async ({ id, contractData }, thunkAPI) => {
    const { dispatch, rejectWithValue } = thunkAPI;
    dispatch(requestStart());

    try {
      const { contract, message, success, error } =
        await contractsClient.updateContract(id, contractData);

      const serverMessage = message || error || 'Failed to update contract';
      if (!success) {
        dispatch(requestFailure(serverMessage));
        return rejectWithValue(serverMessage);
      }

      const mappedContract = mapKeys(contract, (_, key) => camelCase(key));

      const frontendCompatibeContract = {
        id: mappedContract.id,
        userId: mappedContract.userId,
        userEmail: mappedContract.userEmail,
        userFullName: mappedContract.userName,
        name: mappedContract.name,
        customName: contractData.customName || mappedContract.customName,
        price: mappedContract.price,
        createdAt: mappedContract.createdAt,
        updatedAt: mappedContract.updatedAt,
        createdBy: mappedContract.createdBy,
        updatedBy: mappedContract.createdBy
      };

      dispatch(updateContractSuccess(frontendCompatibeContract));
      return frontendCompatibeContract;
    } catch (err) {
      const msg = err?.message || String(err);
      dispatch(requestFailure(msg));
      return rejectWithValue(msg);
    }
  }
);
